import { render, staticRenderFns } from "./historyEdition.vue?vue&type=template&id=6706f5dc&scoped=true&"
import script from "./historyEdition.vue?vue&type=script&lang=js&"
export * from "./historyEdition.vue?vue&type=script&lang=js&"
import style0 from "./historyEdition.vue?vue&type=style&index=0&id=6706f5dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706f5dc",
  null
  
)

export default component.exports